import Vue from 'vue'
import { PullRefresh, List, Switch, Dialog } from 'vant'
import 'vant/lib/pull-refresh/style'
import 'vant/lib/list/style'
import 'vant/lib/switch/style'
import 'vant/lib/dialog/style'
import 'vant/lib/toast/style'

Vue.use(PullRefresh)
Vue.use(List)
Vue.use(Switch)
Vue.use(Dialog.Component)
